import { render, staticRenderFns } from "./PriceEquipmentList.vue?vue&type=template&id=dbfcea9e&scoped=true&"
import script from "./PriceEquipmentList.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PriceEquipmentList.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PriceEquipmentList.vue?vue&type=style&index=0&id=dbfcea9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbfcea9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbfcea9e')) {
      api.createRecord('dbfcea9e', component.options)
    } else {
      api.reload('dbfcea9e', component.options)
    }
    module.hot.accept("./PriceEquipmentList.vue?vue&type=template&id=dbfcea9e&scoped=true&", function () {
      api.rerender('dbfcea9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/components/PriceCatalog/components/PriceEquipmentList.vue"
export default component.exports